module.exports = __webpack_public_path__ + "static/blog-banner-high-res-eb64bec1c3de147b2d314e83cc3e6e35.jpg";